/**
 * List component for transactions, managing list content and implementing event handler
 * 
 * Properties:
 * 
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React, { useState, useEffect} from "react";
import {$, _} from '../../../../../vendor';
import Invoice from "./Invoice";

 const InvoicesList = (props) => {
    const currentUrl = new URL(window.location.href);
    const {invoices,
            dispatch,
        filterChangedHandle,
        filter,
        setFilter,
        sort,
        setSort,
        _key,
        _readFile,
        setKey,
        params,
        showNotification,checkedItems,onCheckBox,withActions
    } = props;

    if(_key !== null){
        let selector = '[key='+_key+']';
        if ($(selector).length >= 1) {
            $('html,body').scrollTop($(selector).offset().top - 10)
        }
    }

    return (
        <>
        <div className='inb-c-listing off-canvas-content' id="inb-c-main-orders" style={{ minHeight: "1150px",paddingTop:"10px"}}>

        { typeof invoices !== 'undefined' && invoices.length > 0 && invoices.map((invoice, index) => {
            return(
                <>
            <Invoice
                invoice={invoice}
                index={index}
                dispatch={dispatch}
                setFilter={setFilter}
                filter={filter}
                setNKey={setKey}
                sort={sort}
                setSort={setSort}
                _key={_key}
                _readFile={_readFile}
                currentUrl={currentUrl}
                filterChangedHandle={filterChangedHandle}
                showNotification={showNotification}
                params={params}
                checkedItems={checkedItems}
                onCheckBox={onCheckBox}
                withActions={withActions}
            /></>);
        })
        }

        </div>
        </>
    );
 };
 export default InvoicesList;